import { useDictionary } from "@/components/DictProvider/DictProvider";
import usePost from "@/hooks/usePost";
import { useLoggedIn } from "@/store/useAuthStore";
import { useNotifyStore } from "@/store/useNotify";
import { useRouter } from "next/navigation";
import React, { useState } from "react";
import toast from "react-hot-toast";

const NotifyButton = ({ productId }) => {
  const { PostMethod } = usePost();
  const { notify, setNotify } = useNotifyStore()
  const { auth } = useLoggedIn();
  const [isShaking, setIsShaking] = useState(false);
  const router = useRouter();
  const dict = useDictionary();

  const isNotified = () => {
    return notify?.some(item => item?.product === productId);
  }

  const handleNotify = async () => {

    try {
      const res = await PostMethod({
        url: `notify/${productId}`,
        method: "get",
      });
      if (res?.success) {
        setNotify(res?.data)
        toast.success(res?.message);
        return;
      }
      toast.error(res?.message || "Failed to send notification");
    } catch (error) {
      toast.error("Failed to send notification");
    }
  }

  const handleClick = (e) => {
    e.stopPropagation();
    if (!auth) {
      toast.error("Please login first");
      router.push("/login");
      return;
    }

    if (isNotified()) {
      toast.success("You're already registered for updates on this item");
      return;  // Return early if user has already sent a notification for this product
    }
    handleNotify();
    setIsShaking(true);
    // Stop shaking after animation completes
    setTimeout(() => setIsShaking(false), 300); // Adjust duration to match animation
  };

  return (
    <button
      className={`text-primary rounded-[6px] border-2 ${isNotified()
        ? "border-transparent bg-primary/10"
        : "border-primary bg-white"
        } w-[91px] h-[32px] flex justify-center items-center gap-1 transition-all duration-200`}
      onClick={handleClick}
    >
      <span className="text-sm">{isNotified() ? dict.cart.notified : dict.cart.notify}</span>
      {isNotified() && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`notify-text ${isShaking ? "shake" : ""}`}
        >
          <g clipPath="url(#clip0_5605_22873)">
            <path
              d="M19 17V11.8C18.5 11.9 18 12 17.5 12H17V18H7V11C7 8.2 9.2 6 12 6C12.1 4.7 12.7 3.6 13.5 2.7C13.2 2.3 12.6 2 12 2C10.9 2 10 2.9 10 4V4.3C7 5.2 5 7.9 5 11V17L3 19V20H21V19L19 17ZM10 21C10 22.1 10.9 23 12 23C13.1 23 14 22.1 14 21H10Z"
              fill="#AC7529"
            />
            <path
              d="M22.3776 3.79109L15.8776 10.2911L12.8984 7.31193L13.6622 6.54818L15.8776 8.75818L21.6139 3.02734L22.3776 3.79109Z"
              fill="#AC7529"
            />
          </g>
          <defs>
            <clipPath id="clip0_5605_22873">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </button>
  );
};

export default NotifyButton;
